var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from "vue-property-decorator";
import Autocomplete from "./autocomplete.vue";
import axios from 'axios';
import { map, throttle } from "lodash-es";
import { bind } from "lodash-decorators";
var InternationalCallRates = /** @class */ (function (_super) {
    __extends(InternationalCallRates, _super);
    function InternationalCallRates() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'international-call-rates';
        _this.autocompleteResults = [];
        _this.selectedRateId = null;
        // @TODO: this was something
        _this.rateDetails = null;
        _this.onInputThrottled = throttle(_this.onInput, 500);
        _this.touched = false;
        _this.showSelectionError = false;
        return _this;
    }
    InternationalCallRates.prototype.onInput = function (_a) {
        var _this = this;
        var value = _a.target.value;
        if (value.length > 0) {
            this.showSelectionError = false;
        }
        if (value.length < 3) {
            return;
        }
        var params = {
            type: 'voip',
            dest: value,
        };
        var queryString = Object.keys(params).map(function (key) { return key + '=' + params[key]; }).join('&');
        axios.get(window.api_url.replace(new RegExp('\/$'), '') + "/search_rates?".concat(queryString)).then(function (response) {
            var data = response.data;
            // @TODO: Add visible error
            if (response.status !== 200 || data.status.toLowerCase() !== 'ok') {
                // There was an issue
                console.error('Error fetching call rates!');
            }
            _this.autocompleteResults = map(data.matches, function (match) {
                return {
                    title: match.destination,
                    value: match.rate_id,
                };
            });
        });
    };
    InternationalCallRates.prototype.onChange = function (_a) {
        var value = _a.value;
        this.selectedRateId = value;
    };
    InternationalCallRates.prototype.onSubmit = function () {
        var _this = this;
        if (!this.selectedRateId) {
            this.showSelectionError = true;
            return;
        }
        var formData = new FormData();
        formData.append('rate_id', String(this.selectedRateId));
        axios.post(window.api_url.replace(new RegExp('\/$'), '') + "/rate_qualification", formData)
            .then(function (response) {
            // @TODO: Add visible error
            if (response.status !== 200 || response.data.status.toLowerCase() !== 'ok') {
                // There was an issue
                console.error('Error fetching call rates!');
            }
            var data = response.data;
            _this.rateDetails = data.rate;
        });
    };
    InternationalCallRates.prototype.formatCurrency = function (number) {
        if (!Intl || typeof Intl !== 'object') {
            return "$".concat(parseFloat(number || '0').toFixed(2));
        }
        var formatter = Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2
        });
        return formatter.format(parseFloat(number || '0'));
    };
    InternationalCallRates.prototype.reset = function () {
        this.selectedRateId = null;
        this.rateDetails = null;
    };
    __decorate([
        Prop({ default: 'phone', type: String })
    ], InternationalCallRates.prototype, "type", void 0);
    __decorate([
        bind(this)
    ], InternationalCallRates.prototype, "onSubmit", null);
    InternationalCallRates = __decorate([
        Component({
            components: { Autocomplete: Autocomplete }
        })
    ], InternationalCallRates);
    return InternationalCallRates;
}(Vue));
export default InternationalCallRates;
